module.exports = __webpack_public_path__ + "img/chapter7.58322143.png";